<template>

    <main class="p-3">
        <messages />
        <slot />
    </main>

</template>

<script>
    import Messages from '@/shared/Messages';

    export default {
        props: [],
        mounted() {
        },
        data() {
            return {
            }
        },
        components: {
            Messages,
        },
        watch: {
        },
    }
</script>